import { useEffect, useState } from 'react';
import { api } from '../lib/api';

// OAuth landing for the Ready.net BOSS Grantor API. Ready redirects the
// browser here with ?code&state after the user authorizes; we hand them to
// the backend to exchange for tokens, then bounce back to the Integrations hub.
export default function ReadyOAuthCallback() {
  const [msg, setMsg] = useState('Connecting to Ready.net…');
  const [err, setErr] = useState(false);

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const code = p.get('code');
    const state = p.get('state');
    if (!code || !state) {
      setErr(true);
      setMsg('Missing code/state in the callback — start Connect again from Settings → Integrations.');
      return;
    }
    (api.post('/ready/oauth/exchange', { code, state }) as Promise<any>)
      .then((r) => {
        if (r?.connected) {
          setMsg('Connected to Ready.net ✓ — taking you back…');
          setTimeout(() => { window.location.href = '/settings/integrations'; }, 1200);
        } else {
          setErr(true);
          setMsg('Exchange failed: ' + JSON.stringify(r));
        }
      })
      .catch((e) => { setErr(true); setMsg('Exchange failed: ' + (e?.message ?? String(e))); });
  }, []);

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 14, background: '#f8fafc' }}>
      <div style={{ fontSize: 24, fontWeight: 700 }}>⚡ Ready.net</div>
      <div style={{ fontSize: 15, color: err ? '#b91c1c' : '#0f172a', maxWidth: 520, textAlign: 'center', padding: '0 16px' }}>{msg}</div>
      {err && <a href="/settings/integrations" style={{ fontSize: 13, color: '#2563eb' }}>Back to Integrations</a>}
    </div>
  );
}
